import { generateColorImages } from '@/api/colorImages';

export class ColorImagesService {
    public static async generate(data: { imagePath: string; colors: string[] }) {
        const { imagePath, colors } = data;

        return await generateColorImages({
            imagePath,
            colors
        });
    }
}
